import { isEqual } from 'lodash';
import LocalStorageHelper from '../utils/LocalStorageHelper';
import { AuthKeys } from '../utils/Constants';
import AuthTypes from '../redux/types/AuthType';

const AuthMiddleware = () => (store) => (next) => (action) => {
  // Get the state before and after the action was performed
  const previousAuth = {
    isAuthenticated: store.getState().User.isAuthenticated,
    language: store.getState().User.userData.language,
    authorization: store.getState().User.authorization,
    idMerchant: store.getState().User.idMerchant,
    userData: store.getState().User.userData,
  };
  next(action);
  const nextAuth = {
    isAuthenticated: store.getState().User.isAuthenticated,
    language: store.getState().User.userData.language,
    authorization: store.getState().User.authorization,
    idUser: store.getState().User.userData.idUser,
    idMerchant: store.getState().User.idMerchant,
    userData: store.getState().User.userData,
  };

  // Respond to changes
  if (nextAuth.isAuthenticated !== previousAuth.isAuthenticated) {
    LocalStorageHelper.storeData(AuthKeys.IS_AUTHENTICATED, nextAuth.isAuthenticated);
    LocalStorageHelper.storeData(AuthKeys.ID_USER, nextAuth.idUser);
  }

  if (nextAuth.language !== previousAuth.language) {
    LocalStorageHelper.storeData(AuthKeys.LANGUAGE, nextAuth.language);
  }

  if (nextAuth.authorization && previousAuth.authorization && !isEqual(nextAuth.authorization, previousAuth.authorization)) {
    LocalStorageHelper.storeData(AuthKeys.AUTHORIZATION, nextAuth.authorization);
  }

  if (nextAuth.userData && previousAuth.userData && !isEqual(nextAuth.userData, previousAuth.userData)) {
    LocalStorageHelper.storeData(AuthKeys.USER_DATA, nextAuth.userData);
  }

  // Clean local storage in logout
  if (action.type === AuthTypes.actions.logoutSuccess) {
    const permanents = ['closeNotification', 'dismissNotifications'];
    for (let i = 0, len = localStorage.length; i < len; i++) {
      const key = localStorage.key(i);
      // eslint-disable-next-line no-unused-expressions
      permanents.indexOf(key) === -1 && localStorage.removeItem(key);
    }
  }
};
export default AuthMiddleware;
